import React, { useState, useEffect, useRef } from 'react';
// components
import BasicCard from './BasicCard';
import TextCard from './TextCard';
import ImageCard from './ImageCard';
import ModalConfirm from './ModalConfirm';
// ui
import Icon from '@material-ui/core/Icon';

const Carousel = ({ outputsEl, index, callbackFromParent, fixedRatio }) => {
    // state
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [checkedType, setCheckedType] = useState(true);

    // 케로셀 아이템 array
    let carouselItems = outputsEl.carousel.items
        ? outputsEl.carousel.items
        : null;
    const carouselType = outputsEl.carousel.type
        ? outputsEl.carousel.type
        : null;

    // 없는 타입일 경우 에러 표시
    useEffect(() => {
        if (
            !(
                carouselType === 'textCard' ||
                carouselType === 'basicCard' ||
                carouselType === 'imageCard'
            )
        ) {
            setCheckedType(false);
        } else {
            setCheckedType(true);
        }
    }, [carouselType]);

    // description maxLength
    // 카드 갯수 체크
    let hasItem =
        outputsEl.carousel.items && outputsEl.carousel.items.length
            ? outputsEl.carousel.items.length
            : null;
    // 텍스트 카드: 단일 400자, 다중 128자
    let maxLengthValue = 128;
    // 베이직 카드: 단일 230자, 다중 76자
    let maxLengthValueB = 76;
    // maxLength change
    if (hasItem === 1 && carouselType === 'textCard') {
        maxLengthValue = 400;
    } else if (hasItem === 1 && carouselType === 'basicCard') {
        maxLengthValueB = 230;
    }

    // title, description 콜백
    const onChangeTxt = (e) => {
        const updatedItems = [...carouselItems];
        updatedItems[e.target.dataset.idx][e.target.className] = e.target.value;

        const carouselObj = {
            carousel: {
                type: carouselType,
                random: outputsEl.carousel.random,
                items: updatedItems,
            },
            index: index,
        };
        callbackFromParent(carouselObj);
    };

    // 버튼 리스트 콜백
    const changeBtnList = (buttonsList, carouselItemIdx) => {
        carouselItems[carouselItemIdx].buttons = buttonsList;
        if (!buttonsList.length) {
            delete carouselItems[carouselItemIdx].buttons;
        }
        const carouselObj = {
            carousel: {
                type: carouselType,
                random: outputsEl.carousel.random,
                items: carouselItems,
            },
            index: index,
        };
        callbackFromParent(carouselObj);
    };

    // 카드 아이템 추가
    let newData = {};
    const onClickAddItem = () => {
        if (carouselType === 'basicCard') {
            if (!fixedRatio) {
                newData = {
                    title: '',
                    description: '',
                };
            } else {
                newData = {
                    title: '',
                    description: '',
                    thumbnail: {
                        fixedRatio: true,
                    },
                };
            }
        } else if (carouselType === 'textCard') {
            if (hasItem === 1) {
                setIsOpenModal(true);
            } else {
                newData = {
                    description: '',
                };
            }
        } else if (carouselType === 'imageCard') {
            newData = {
                thumbnail: {
                    imageUrl: '',
                },
            };
        } else {
            alert('잘못된 응답 타입입니다.');
            return false;
        }

        // 빈 객체가 아닐때! (랜덤 걸어야하나)
        if (Object.keys(newData).length !== 0) {
            let carouselObj = {};
            if (carouselType !== 'textCard') {
                carouselObj = {
                    carousel: {
                        type: carouselType,
                        items: [...carouselItems, newData],
                    },
                    index: index,
                };
            } else {
                carouselObj = {
                    carousel: {
                        type: carouselType,
                        random: outputsEl.carousel.random,
                        items: [...carouselItems, newData],
                    },
                    index: index,
                };
            }

            callbackFromParent(carouselObj);
        }
    };

    // 아이템 추가 확인, 모달에서 콜백
    const callBackConfirmAction = (action, type) => {
        if (action === 'submit') {
            let newData = {
                description: '',
            };
            const carouselObj = {
                carousel: {
                    type: carouselType,
                    random: outputsEl.carousel.random,
                    items: [...carouselItems, newData],
                },
                index: index,
            };

            callbackFromParent(carouselObj);
            setIsOpenModal(false);
        } else {
            setIsOpenModal(false);
        }
    };

    // 순서 변경 및 제거
    const callBackhandleItem = (action, itemsIdx) => {
        // 순서 변경
        if (action) {
            // 해당 아이템 뽑음
            let selectedItem = carouselItems.filter(
                (num) => num === carouselItems[itemsIdx]
            );
            //selectedItem = [Object.assign({}, selectedItem[0])];

            selectedItem = JSON.parse(JSON.stringify(selectedItem[0]));

            // 핸들러
            if (action === 'up' && itemsIdx > 0) {
                carouselItems.splice(itemsIdx, 1);
                carouselItems.splice(itemsIdx - 1, 0, selectedItem);
            } else if (
                action === 'down' &&
                itemsIdx < carouselItems.length - 1
            ) {
                carouselItems.splice(itemsIdx, 1);
                carouselItems.splice(itemsIdx + 1, 0, selectedItem);
            } else if (action === 'copy') {
                if (hasItem < 10) {
                    carouselItems.splice(itemsIdx + 1, 0, selectedItem);
                }
            } else if (action === 'del') {
                carouselItems = carouselItems.filter(
                    (num) => num !== carouselItems[itemsIdx]
                );
            } else {
                console.log('no case');
            }
        }

        //  변경된 데이터 넣음
        let resultObj = {
            carousel: {
                type: carouselType,
                random: outputsEl.carousel.random,
                items: carouselItems,
            },
            index: index,
        };

        // 부모한테 전달
        callbackFromParent(resultObj);
    };

    // 텍스트 카드 > 심플 텍스트
    const cardtoText = () => {
        let resultObj;
        if (carouselType === 'textCard') {
            if (hasItem === 0) {
                resultObj = {
                    simpleText: {},
                    index: index,
                };
                // 부모한테 전달
                callbackFromParent(resultObj);
            } else if (hasItem === 1 && !outputsEl.carousel.items[0].buttons) {
                resultObj = {
                    simpleText: {
                        text: outputsEl.carousel.items[0].description,
                    },
                    index: index,
                };
                // 부모한테 전달
                callbackFromParent(resultObj);
            }
        }
    };

    // 이미지 카드 > 심플 이미지
    const cardtoImg = () => {
        let resultObj;
        if (carouselType === 'imageCard') {
            if (hasItem === 0) {
                resultObj = {
                    simpleImage: {
                        imageUrl: '',
                        altText: '',
                    },
                    index: index,
                };
                // 부모한테 전달
                callbackFromParent(resultObj);
            } else if (hasItem === 1) {
                resultObj = {
                    simpleImage: {
                        imageUrl:
                            outputsEl.carousel.items[0].thumbnail.imageUrl,
                        altText: '',
                    },
                    index: index,
                };
                // 부모한테 전달
                callbackFromParent(resultObj);
            }
        }
    };

    // 일단..  카드 > 심플 (여기서 자꾸 경고 뜸)
    useEffect(() => {
        cardtoText();
        cardtoImg();
    }, [outputsEl]);

    // 모달 위치
    const modalNode = useRef();
    // 모달 닫기
    const closeSet = (e) => {
        if (modalNode.current.contains(e.target)) {
            // inside click
            return;
        }
        setIsOpenModal(false);
    };
    // 모달 닫기
    useEffect(() => {
        // add when mounted
        document.addEventListener('mousedown', closeSet);
        // return function to be called when unmounted
        return () => {
            document.removeEventListener('mousedown', closeSet);
        };
    }, []);

    // 아이템 리스트
    let list;
    if (carouselItems) {
        list = carouselItems.map(function (el, itemsIdx) {
            if (carouselType === 'basicCard') {
                return (
                    <BasicCard
                        key={`item-cont-${itemsIdx}`}
                        el={el}
                        index={index}
                        itemsIdx={itemsIdx}
                        onChangeTxt={onChangeTxt}
                        changeBtnList={changeBtnList}
                        outputsEl={outputsEl}
                        callbackFromParent={callbackFromParent}
                        callBackhandleItem={callBackhandleItem}
                        maxLengthValueB={maxLengthValueB}
                        hasItem={hasItem}
                        fixedRatio={fixedRatio}
                    />
                );
            } else if (carouselType === 'textCard') {
                return (
                    <TextCard
                        key={`item-cont-${itemsIdx}`}
                        el={el}
                        itemsIdx={itemsIdx}
                        onChangeTxt={onChangeTxt}
                        changeBtnList={changeBtnList}
                        outputsEl={outputsEl}
                        callBackhandleItem={callBackhandleItem}
                        maxLengthValue={maxLengthValue}
                        hasItem={hasItem}
                    />
                );
            } else if (carouselType === 'imageCard') {
                return (
                    <ImageCard
                        key={`item-cont-${itemsIdx}`}
                        el={el}
                        itemsIdx={itemsIdx}
                        outputsEl={outputsEl}
                        callbackFromParent={callbackFromParent}
                        callBackhandleItem={callBackhandleItem}
                        hasItem={hasItem}
                    />
                );
            } else {
                return null;
            }
        });
    } else {
        return <div className="error-res">잘못된 응답 타입입니다.</div>;
    }

    return (
        <>
            {checkedType ? (
                list
            ) : (
                <div className="error-res">잘못된 응답 타입입니다.</div>
            )}
            {checkedType && carouselItems.length < 10 && (
                <div className="item-cont">
                    <div className={`item add ${hasItem ? 'card' : ''}`}>
                        <button type="button" onClick={onClickAddItem}>
                            <Icon>add_circle_outline</Icon>
                        </button>
                    </div>
                </div>
            )}
            <div ref={modalNode}>
                {isOpenModal && (
                    <ModalConfirm
                        callBackConfirmAction={callBackConfirmAction}
                        addAtion="addItem"
                    />
                )}
            </div>
        </>
    );
};

Carousel.defaultProps = {
    // bla: 'test',
};

export default Carousel;
